import { LeafLabel } from "./label.component.js";
customElements.define("leaf-label", LeafLabel);
export {
  LeafLabel
};
//# sourceMappingURL=label.js.map
